import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { END_LOADING, START_LOADING, UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';

import { provider as apiProvider } from '../api';
import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { listMutations, listActions } from './types';

const paramsWithDefault = (state: { localState: LocalState }) => ({
	ZaznamId: state.localState.selectedPacket!.ZaznamId,
	MechanikId: state.localState.pracovnikId || state.localState.selectedPacket!.PracovnikId,
	ProvozovnaId: state.localState.provozovnaId || state.localState.selectedPacket!.ProvozovnaId,
	StredNaklOzn: state.localState.strednaklOzn || state.localState.selectedPacket!.StrednaklOzn,
});

class LocalState {
	selectedPacketId: number | null = null;
	selectedPacket: null | Record<string, any> = null;
	pracovnikId: null | number = null;
	provozovnaId: null | number = null;
	strednaklOzn: null | string = null;
	strednaklOznText: null | string = null;
	pracovnikIdText: null | string = null;
	pracovnikOsobniCis: null | string = null;
	dropDownProvozovnaId: null | Record<string, any>[] = [];
}

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		StredNaklOzn: [],
		ProvozovnaId: [],
	},
	filter: {},
	tableSetting: {},
	rowDetail: null,
	localState: new LocalState(),
	extraActions: {
		async [listActions.UPDATE_FILTER]({ state, commit }, filter) {
			commit(`${UPDATE_BASIC_FILTER}`, { Filter: filter });
		},
		async [listActions.FETCH_PACKET_DETAIL]({ state, commit }, id) {
			const { data } = await apiProvider.entity(id);
			commit(listMutations.SET_PACKET_DETAIL, data);
		},
		async [listActions.FILTER_INIT]({ state, commit }) {
			const { data } = await apiProvider.filterInit({ ZakazkaId: state.props.filter.ZakazkaId });
			commit(listMutations.SET_PACKET_DETAIL, { ...data.Filter, DropDownList: data.DropDownList });
		},
		async [listActions.PREPOCET_CENY]({ state }) {
			return apiProvider.prepocetCeny({
				ZakazkaId: state.props.filter.ZakazkaId,
				PracovnikId: state.localState.pracovnikId || state.localState.selectedPacket!.PracovnikId,
				...paramsWithDefault(state),
			});
		},
		async [listActions.ODEPIS_PP]({ state }) {
			return apiProvider.odepisPp(paramsWithDefault(state));
		},
		async [listActions.ODEPIS_ND]({ state }) {
			return apiProvider.odepisNd(paramsWithDefault(state));
		},
		async [listActions.DELETE_PACKET]({ state }) {
			return apiProvider.deletePacket(state.localState.selectedPacketId!);
		},
		async [listActions.ROZPAD_PACKETU]({ state }) {
			return apiProvider.rozpadPacketu(
				state.localState.selectedPacket!.ZaznamId,
				state.props.filter.ZakazkaId!,
			);
		},
	},
	extraMutations: {
		[START_LOADING](state) {
			state.loadingCount += 1;
		},
		[END_LOADING](state) {
			state.loadingCount -= 1;
		},
		[listMutations.SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.localState.strednaklOzn = data.value;
			state.localState.strednaklOznText = data.text;
			if (!data.isClear) {
				state.localState.provozovnaId = data.provozovnaId;
			}
		},
		[listMutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.localState.pracovnikId = data.value;
			state.localState.pracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.localState.pracovnikOsobniCis = data.osobniCis;
			state.localState.provozovnaId = data.provozovnaId;
			state.localState.strednaklOzn = data.strednaklOzn;
			state.localState.strednaklOznText = data.strednaklOznText;
		},
		[listMutations.SET_PACKET_DETAIL](state, detail) {
			state.localState.pracovnikId = detail.PracovnikId;
			state.localState.provozovnaId = detail.ProvozovnaId;
			state.localState.pracovnikOsobniCis = detail.PracovnikOsobniCis;
			state.localState.strednaklOzn = detail.StrednaklOzn;
			state.localState.strednaklOznText = detail.StrednaklOznText;
			state.localState.pracovnikIdText = detail.PracovnikIdText;
			state.localState.dropDownProvozovnaId = detail.DropDownList.ProvozovnaId;
		},
	},
	extraGetters: {},
	props: {
		filter: {
			ZakazkaId: null as number | null,
		},
		mode: null,
		afterRowSelection: () => {},
	},
});
